import BaseComponent from 'foundation/base-component';
import anime from 'animejs';
import gtm from 'general/js/gtm';
import eventBus from '../../../general/js/event-bus';
import { EVENT_DEVICE_TYPE_CHANGED } from '../../../general/js/app';

const EASING = 'easeOutQuad';
const DURATION_OPEN = 400;
const DURATION_CLOSE = 300;
const DURATION_SLIDE = 284;

export default class Header extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.visibleLocation = false;
        this.visibleLocationLatest = false;
        this.locationPanelHeight = this.refs.location.offsetHeight;
        this.headerCanBeAnimated = true;
        this.menuCanBeAnimated = true;
        this.keyboardEvent = false;

        this.init();
    }

    init() {
        if (this.refs.dynamicButton) {
            this.refs.dynamicButton.forEach((button) => {
                this.addListener(button, 'click', this.onClickDynamicButton);
                this.addListener(button, 'keypress', this.onKeypressDynamicButton);
            });
        }

        if (this.refs.dynamicButtonLatest) {
            this.refs.dynamicButtonLatest.forEach((button) => {
                this.addListener(button, 'click', this.onClickDynamicButtonLatest);
                this.addListener(button, 'keypress', this.onKeypressDynamicButtonLatest);
            });
        }

        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onChangeDeviceType);
        this.addListener(this.refs.gtmLeftMenuClick, 'click', this.saveActionToGtm);
        this.addListener(this.refs.gtmDynamicMenuClick, 'click', this.saveActionToGtm);
    }

    onDestroy() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onChangeDeviceType);
    }

    saveActionToGtm = (event) => {
        const clickedItem = event.target;
        const itemText = clickedItem.innerText || clickedItem.textContent;

        gtm.push('Top Ribbon', 'Click', itemText);
    }

    onChangeDeviceType = () => {
        this.refs.location.classList.remove('is-hidden');
        this.refs.locationLatest.classList.remove('is-hidden');
        this.locationPanelHeight = this.refs.location.offsetHeight;

        if (!this.visibleLocation) {
            anime({
                targets: this.refs.location,
                marginTop: -this.locationPanelHeight,
                duration: 0,
                easing: EASING
            });
        }
        if (!this.visibleLocationLatest) {
            anime({
                targets: this.refs.locationLatest,
                marginTop: -this.locationPanelHeight,
                duration: 0,
                easing: EASING
            });
        }
    }

    setAnimation(arrayItems, boolean) {
        if (boolean) {
            [...arrayItems].forEach((item) => {
                item.classList.add('is-animation');
            });
        } else {
            [...arrayItems].forEach((item) => {
                item.classList.remove('is-animation');
            });
        }
    }

    ariaExpandedTrigger(array, state) {
        array.forEach((item) => {
            item.setAttribute('aria-expanded', state);
        });
    }

    async toggleLocationsPanel(location, dynamicButton, cb) {
        this.locationPanelHeight = location.offsetHeight;

        if (this.headerCanBeAnimated) {
            this.headerCanBeAnimated = false;

            switch (location.className.includes('__latest')) {
                case true:
                    if (this.visibleLocationLatest) {
                        this.closingMenuAnimation(location, dynamicButton);
                        this.visibleLocationLatest = false;
                    } else {
                        if (this.closeOtherMenuAnimation(location)) {
                            await this.timeout(DURATION_SLIDE);
                        }

                        this.openingMenuAnimation(location, dynamicButton, cb);
                        this.visibleLocationLatest = true;
                    }
                    break;
                case false:
                    if (this.visibleLocation) {
                        this.closingMenuAnimation(location, dynamicButton);
                        this.visibleLocation = false;
                    } else {
                        if (this.closeOtherMenuAnimation(location)) {
                            await this.timeout(DURATION_SLIDE);
                        }

                        this.openingMenuAnimation(location, dynamicButton, cb);
                        this.visibleLocation = true;
                    }
                    break;
                default:
                    break;
            }
        }
    }

    onKeypressDynamicButton = (event) => {
        this.keyboardEvent = true;
        event.preventDefault();
        this.toggleLocationsPanel(this.refs.location, this.refs.dynamicButton, this.setFocus(this.refs.locationLink));
    }

    onKeypressDynamicButtonLatest = (event) => {
        this.keyboardEvent = true;

        event.preventDefault();
        this.toggleLocationsPanel(this.refs.locationLatest, this.refs.dynamicButtonLatest, this.setFocus(this.refs.locationLinkLatest));
    }

    onClickDynamicButton = (event) => {
        if (this.keyboardEvent) return;

        event.preventDefault();
        this.toggleLocationsPanel(this.refs.location, this.refs.dynamicButton);
    }

    onClickDynamicButtonLatest = (event) => {
        if (this.keyboardEvent) return;

        event.preventDefault();
        this.toggleLocationsPanel(this.refs.locationLatest, this.refs.dynamicButtonLatest);
    }

    openingMenuAnimation(location, dynamicButton, cb) {
        this.ariaExpandedTrigger(dynamicButton, 'true');

        location.classList.remove('is-hidden');
        location.classList.add('is-visible');

        if (location.className.includes('__latest')) {
            this.setAnimation(this.refs.dynamicIconsLatest, true);
            window.setTimeout(() => {
                this.setAnimation(this.refs.locationItemLatest, true);
            }, 1);
            this.setAnimation(this.refs.locationLinkLatest, true);
        } else {
            this.setAnimation(this.refs.dynamicIcons, true);
            window.setTimeout(() => {
                this.setAnimation(this.refs.locationItem, true);
            }, 1);
            this.setAnimation(this.refs.locationLink, true);
        }

        anime({
            targets: location,
            marginTop: 0,
            duration: DURATION_OPEN,
            easing: EASING,
            complete: () => {
                this.keyboardEvent = false;
                this.headerCanBeAnimated = true;
                if (typeof cb === 'function') {
                    cb();
                }
            }
        });
    }

    closingMenuAnimation(location, dynamicButton) {
        this.ariaExpandedTrigger(dynamicButton, 'false');

        if (location.className.includes('__latest')) {
            this.setAnimation(this.refs.dynamicIconsLatest, false);
            this.setAnimation(this.refs.locationItemLatest, false);
            this.setAnimation(this.refs.locationLinkLatest, false);
        } else {
            this.setAnimation(this.refs.dynamicIcons, false);
            this.setAnimation(this.refs.locationItem, false);
            this.setAnimation(this.refs.locationLink, false);
        }

        anime({
            targets: location,
            marginTop: -this.locationPanelHeight,
            duration: DURATION_CLOSE,
            easing: EASING,
            complete: () => {
                location.classList.remove('is-visible');
                location.classList.add('is-hidden');
                this.keyboardEvent = false;
                this.headerCanBeAnimated = true;
            }
        });
    }

    closeOtherMenuAnimation(location) {
        if (location.className.includes('__latest')) {
            if (this.visibleLocation) {
                this.closingMenuAnimation(this.refs.location, this.refs.dynamicButton);
                this.visibleLocation = false;
                return true;
            }
        } else if (this.visibleLocationLatest) {
            this.closingMenuAnimation(this.refs.locationLatest, this.refs.dynamicButtonLatest);
            this.visibleLocationLatest = false;
            return true;
        }
        return false;
    }

    async timeout(interval) {
        return new Promise((resolve) => setTimeout(resolve, interval));
    }

    setFocus = (locationLink) => {
        locationLink[0].focus();
    };
}
